import type { ClientStatus } from "./types/clients.types";

/** The one palette a client's status is drawn in, wherever the row appears —
 *  My clients and the dashboard's recent list both read from this, so the same
 *  status never arrives in two different colours. */
export const CLIENT_STATUS_STYLES: Record<ClientStatus, string> = {
  "Ending soon": "bg-[#FDECEC] text-[#D14343]",
  Active: "bg-brand-soft text-[#00899B]",
  Inactive: "bg-[#F1F4F6] text-ink-muted",
  // Blue rather than another shade of the brand teal: a new client is not a
  // weaker kind of active one, and the two badges sit in the same column.
  New: "bg-[#DEEBFB] text-[#2F6BAE]",
};
